/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Point_Pilot_BodyInputs */

const en_contact_point_pilot_body = /** @type {(inputs: Contact_Point_Pilot_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We index a slice of your published research so you can judge the output on your own coverage, not a generic dataset.`)
};

/**
* | output |
* | --- |
* | "We index a slice of your published research so you can judge the output on your own coverage, not a generic dataset." |
*
* @param {Contact_Point_Pilot_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_point_pilot_body = /** @type {((inputs?: Contact_Point_Pilot_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Point_Pilot_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_point_pilot_body(inputs)
});